import { render } from "./TaskTypeDialog.vue?vue&type=template&id=4a032af8"
import script from "./TaskTypeDialog.vue?vue&type=script&lang=js"
export * from "./TaskTypeDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__